import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);

const DEFAULT_CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "EUR", symbol: "€", name: "Euro" },
];

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("fba_currency") || "USD");
  const [currencies, setCurrencies] = useState(DEFAULT_CURRENCIES);
  const [rates, setRates] = useState({});
  const [fxUpdatedAt, setFxUpdatedAt] = useState(null);
  const [fxSource, setFxSource] = useState(null);

  useEffect(() => {
    api.get("/fx/rates")
      .then((r) => {
        if (r.data?.currencies?.length) setCurrencies(r.data.currencies);
        setRates(r.data?.usd_per || {});
        setFxUpdatedAt(r.data?.updated_at || null);
        setFxSource(r.data?.source || null);
      })
      .catch(() => { /* keep defaults */ });
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("fba_currency", c);
  };

  // Convert an amount from `fromCur` into the active display currency using live rates.
  const toDisplay = (amount, fromCur = "USD") => {
    const a = Number(amount) || 0;
    const upFrom = rates[fromCur] ?? (fromCur === "USD" ? 1 : null);
    const upTo = rates[currency] ?? (currency === "USD" ? 1 : null);
    if (!upFrom || !upTo) return a;
    return (a * upFrom) / upTo;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, currencies, rates, fxUpdatedAt, fxSource, toDisplay }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
